import { useNavigate, useSearchParams } from "react-router-dom";

import AccessGroupDeleteForm from "./AccessGroupDeleteConfirmationForm";
import AccessGroupForm from "features/admin/access-groups/AccessGroupForm";
import AccessGroupTable from "features/admin/access-groups/AccessGroupTable";
import CustomGroupContext from "features/allocations/contexts/CustomGroupContext";
import DrawerContext from "shared/contexts/DrawerContext";
import MasterDrawer from "shared/components/data-display/drawers/MasterDrawer";
import Modal from "shared/components/feedback/modals/MasterModal";
import PageWrapper from "app/components/PageWrapper";
import SearchEmployeeNew from "features/allocations/components/grid/employee/SearchEmployeeNew";
import { useContext } from "react";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal title="Add Access Group" onRequestClose={onClose}>
                <AccessGroupForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Edit Access Group" onRequestClose={onClose}>
                <AccessGroupForm
                    accessGroupIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    if (action === "delete" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Delete Access Group" onRequestClose={onClose}>
                <AccessGroupDeleteForm
                    accessGroupIdToDelete={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const AccessGroups = () => {
    const customGroupConsumer = useContext(CustomGroupContext);
    const { displaySearch, handleSearchEmployeeClick } =
        useContext(DrawerContext);

    return (
        <PageWrapper
            title="Access Groups"
            description="View and manage permissions to access pages and actions."
            menuOptions={[{ children: "Admin", to: "/admin" }]}
            breadcrumbMarginBottom="16px"
        >
            <FormPresenter />
            <AccessGroupTable onSearchClick={handleSearchEmployeeClick} />
            <MasterDrawer stickyAction={!displaySearch}>
                <CustomGroupContext.Provider value={customGroupConsumer}>
                    <SearchEmployeeNew />
                </CustomGroupContext.Provider>
            </MasterDrawer>
        </PageWrapper>
    );
};

export default AccessGroups;
